import styled from 'styled-components'
import { BLACK } from '@styles/colors'
import { INTER } from '@styles/fonts'

import JIDRCardBackgroundSrc from '@assets/images/JIDRCardBackground.png'

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 5px;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(90deg, #CDDFFA88 0%, #F9FAFB 100%);
  overflow: hidden;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
  padding: 32px 18px;
`

export const AmountLabel = styled.span`
  font-family: ${INTER.regular};
  color: ${BLACK};
  font-size: 12px;
`

export const AmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
`

export const AmountValue = styled.span`
  font-family: ${INTER.bold};
  font-size: 18px;
  color: ${BLACK};
`

export const CopyButtonContainer = styled.div`
  position: absolute;
  right: 12px;
  bottom: 30%;
  z-index: 1000;
  cursor: pointer;
`

export const JIDRCardBackground = styled.img.attrs({
  src: JIDRCardBackgroundSrc
})`
  height: 100%;
  width: 20%;
  position: absolute;
  right: 0;
  top: 0;
`
